import React from 'react';
import ME from '../../assets/me.png';
import CTA from './CTA';
import HeaderSocials from './HeaderSocials';
import './Header.css';

const Header = ({ t }) => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>{t("header-title")}</h5>
        <h1>{t("header-subtitle")}</h1>
        <h5 className="text_light">{t("header-job")}</h5>
        <CTA t={ t }/>
        <HeaderSocials />

        <div className="me">
          <img src={ ME } alt="Rafael Castro" />
        </div>

        <a href="#contact" className="scroll__down">{t("header-scroll-down")}</a>
      </div>
    </header>
  )
}

export default Header;
